export function EcosystemIcon1(props) {
  return (
    <svg
      width="9.7rem"
      height="9.1rem"
      viewBox="0 0 97 91"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path id="a" d="M0 90L96 90 96 0 0 0z" />
      </defs>
      <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <path
          d="M57.879 78l-3 3H41.121l-2.998-3H0v5.122L6.879 90h82.243L96 83.122V78H57.879zM56.121 84l3-3.001H93v.879l-5.121 5.12H8.122L3 81.88v-.88h33.88l2.999 3.002h16.242z"
          fill="#222829"
          transform="translate(-513 -3995) translate(466.795 3941) translate(46.65 54.65)"
        />
        <g transform="translate(-513 -3995) translate(466.795 3941) translate(46.65 54.65)">
          <path d="M9 75H6V30c0-3.309 2.691-6 6-6h9v3h-9c-1.655 0-3 1.346-3 3v45z" fill="#222829" />
          <mask id="b" fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <path fill="#222829" mask="url(#b)" d="M87 75L90 75 90 49.5 87 49.5z" />
          <path fill="#222829" mask="url(#b)" d="M84 72L12 72 12 30 21 30 21 33 15 33 15 69 81 69 81 49.5 84 49.5z" />
          <path fill="#222829" mask="url(#b)" d="M75 46.5L87 46.5 87 43.5 75 43.5z" />
          <path fill="#222829" mask="url(#b)" d="M30 18L66 18 66 15 30 15z" />
          <path fill="#222829" mask="url(#b)" d="M30 24L66 24 66 21 30 21z" />
          <path fill="#222829" mask="url(#b)" d="M30 30L66 30 66 27 30 27z" />
          <path d="M27 66h-3V9c0-4.963 4.037-9 9-9h43.5v3H33c-3.309 0-6 2.691-6 6v57z" fill="#222829" mask="url(#b)" />
          <path fill="#222829" mask="url(#b)" d="M46.5 12L49.5 12 49.5 9 46.5 9z" />
          <path fill="#222829" mask="url(#b)" d="M40.5 12L43.5 12 43.5 9 40.5 9z" />
          <path fill="#222829" mask="url(#b)" d="M52.5 12L55.5 12 55.5 9 52.5 9z" />
          <path
            d="M72 66h-3V7.5C69 3.364 72.365 0 76.5 0S84 3.365 84 7.5v33c0 1.654 1.346 3 3 3s3-1.346 3-3V12h-3V9h6v31.5c0 3.309-2.691 6-6 6s-6-2.691-6-6v-33C81 5.019 78.981 3 76.5 3A4.505 4.505 0 0072 7.5V66zM48 60c-3.309 0-6-2.691-6-6h3c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.974-2.136-2.469-3.614-3.13C46.486 50.465 42 48.29 42 45c0-3.309 2.691-6 6-6s6 2.691 6 6h-3c0-1.654-1.346-3-3-3s-3 1.346-3 3c0 .974 2.136 2.469 3.614 3.13.9.404 5.386 2.58 5.386 5.87 0 3.309-2.691 6-6 6"
            fill="#222829"
            mask="url(#b)"
          />
          <path fill="#222829" mask="url(#b)" d="M46.5 40.5L49.5 40.5 49.5 36 46.5 36z" />
          <path fill="#222829" mask="url(#b)" d="M46.5 63L49.5 63 49.5 58.5 46.5 58.5z" />
          <path fill="#222829" mask="url(#b)" d="M57 51L60 51 60 48 57 48z" />
          <path fill="#222829" mask="url(#b)" d="M36 51L39 51 39 48 36 48z" />
        </g>
      </g>
    </svg>
  );
}

export function EcosystemIcon2(props) {
  return (
    <svg
      width="9.7rem"
      height="9.1rem"
      viewBox="0 0 97 91"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path id="a" d="M0 90L96 90 96 0 0 0z" />
      </defs>
      <g
        transform="translate(-513 -4282) translate(466.795 4228.313) translate(46.65 54.65)"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M93 90H3c-1.655 0-3-1.346-3-3V39c0-1.654 1.345-3 3-3h28.5v3H3v48h90V39H64.5v-3H93c1.654 0 3 1.346 3 3v48c0 1.654-1.346 3-3 3"
          fill="#222829"
        />
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path fill="#222829" mask="url(#b)" d="M81 88.5L84 88.5 84 42 81 42z" />
        <path fill="#222829" mask="url(#b)" d="M87 64.5L90 64.5 90 61.5 87 61.5z" />
        <path fill="#222829" mask="url(#b)" d="M87 58.5L90 58.5 90 55.5 87 55.5z" />
        <path fill="#222829" mask="url(#b)" d="M87 70.5L90 70.5 90 67.5 87 67.5z" />
        <path fill="#222829" mask="url(#b)" d="M12 84L15 84 15 39 12 39z" />
        <path fill="#222829" mask="url(#b)" d="M6 67.5L9 67.5 9 58.5 6 58.5z" />
        <path fill="#222829" mask="url(#b)" d="M46.5 84L49.5 84 49.5 58.5 46.5 58.5z" />
        <path
          d="M35.698 25.07A13.406 13.406 0 0134.5 19.5C34.5 12.055 40.555 6 48 6c7.444 0 13.5 6.055 13.5 13.5 0 1.912-.392 3.762-1.164 5.491l-2.74-1.22c.6-1.346.904-2.782.904-4.271C58.5 13.71 53.79 9 48 9 42.21 9 37.5 13.71 37.5 19.5c0 1.51.313 2.968.931 4.33l-2.733 1.24z"
          fill="#222829"
          mask="url(#b)"
        />
        <path
          d="M64.89 29.252l-2.595-1.503A16.494 16.494 0 0064.5 19.5C64.5 10.402 57.099 3 48 3c-9.098 0-16.5 7.402-16.5 16.5 0 2.904.763 5.756 2.206 8.248l-2.596 1.503A19.494 19.494 0 0128.5 19.5C28.5 8.748 37.248 0 48 0s19.5 8.748 19.5 19.5c0 3.429-.902 6.801-2.61 9.752"
          fill="#222829"
          mask="url(#b)"
        />
        <path fill="#222829" mask="url(#b)" d="M0 21L21 21 21 18 0 18z" />
        <path fill="#222829" mask="url(#b)" d="M16.0605 26.5605L13.9395 24.4395 18.879 19.5 13.9395 14.5605 16.0605 12.4395 23.121 19.5z" />
        <path fill="#222829" mask="url(#b)" d="M75 21L96 21 96 18 75 18z" />
        <path fill="#222829" mask="url(#b)" d="M79.9395 26.5605L72.879 19.5 79.9395 12.4395 82.0605 14.5605 77.121 19.5 82.0605 24.4395z" />
        <path
          d="M48 16.5c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3m0 9c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6M57 84h-3V55.5h4.5V33c0-1.654-1.346-3-3-3h-2.379L48 35.121 42.879 30H40.5c-1.654 0-3 1.346-3 3v22.5H42V84h-3V58.5h-4.5V33c0-3.309 2.691-6 6-6h3.621L48 30.879 51.879 27H55.5c3.309 0 6 2.691 6 6v25.5H57V84z"
          fill="#222829"
          mask="url(#b)"
        />
      </g>
    </svg>
  );
}

export function EcosystemIcon3(props) {
  return (
    <svg
      width="7.9rem"
      height="9.7rem"
      viewBox="0 0 79 97"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path id="a" d="M0 96L78 96 78 0 0 0z" />
      </defs>
      <g transform="translate(-522 -4566) translate(522.446 4566.277)" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <path
          d="M78 96h-3c0-8.796-1.431-12.396-9.474-15.076l-15.363-6.179C49.788 74.493 46.5 72.192 46.5 69v-1.5h3V69c0 1.305 1.603 2.72 2.22 3.172l14.838 5.934C76.275 81.344 78 86.46 78 96M3 96H0c0-9.54 1.725-14.656 11.526-17.924l14.754-5.903c.682-.502 2.22-1.894 2.22-3.173v-1.5h3V69c0 3.192-3.288 5.493-3.663 5.745l-.279.148-15 6C4.431 83.605 3 87.204 3 96"
          fill="#222829"
        />
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path fill="#222829" mask="url(#b)" d="M37.5 93L40.5 93 40.5 90 37.5 90z" />
        <path fill="#222829" mask="url(#b)" d="M37.5 87L40.5 87 40.5 84 37.5 84z" />
        <path
          d="M66 63H49.5v-3H66V27H12v33h16.5v3H12c-1.655 0-3-1.346-3-3V27c0-1.654 1.345-3 3-3h54c1.654 0 3 1.346 3 3v33c0 1.654-1.346 3-3 3"
          fill="#222829"
          mask="url(#b)"
        />
        <path
          d="M10.5 21A4.505 4.505 0 006 25.5v36c0 2.481 2.019 4.5 4.5 4.5h57c2.481 0 4.5-2.019 4.5-4.5v-36c0-2.481-2.019-4.5-4.5-4.5h-57zm57 48h-57C6.364 69 3 65.635 3 61.5v-36c0-4.136 3.364-7.5 7.5-7.5h57c4.135 0 7.5 3.364 7.5 7.5v36c0 4.135-3.365 7.5-7.5 7.5z"
          fill="#222829"
          mask="url(#b)"
        />
        <path
          d="M39 21c-.384 0-.768-.147-1.06-.44l-12-12a1.498 1.498 0 010-2.12 1.498 1.498 0 012.12 0l12 12A1.498 1.498 0 0139 21"
          fill="#222829"
          mask="url(#b)"
        />
        <path
          d="M39 21a1.498 1.498 0 01-1.06-2.56l18-18a1.498 1.498 0 012.12 0 1.498 1.498 0 010 2.12l-18 18c-.292.293-.676.44-1.06.44M39 81c-7.697 0-13.5-3.224-13.5-7.5h3c0 2.124 4.491 4.5 10.5 4.5s10.5-2.376 10.5-4.5h3c0 4.276-5.803 7.5-13.5 7.5M63 37.5c-2.124 0-3.245-1.122-4.062-1.94-.733-.735-1.094-1.06-1.938-1.06-.844 0-1.205.325-1.938 1.06-.817.818-1.938 1.94-4.062 1.94-2.121 0-3.242-1.12-4.06-1.94-.737-.735-1.097-1.06-1.94-1.06s-1.205.325-1.94 1.062c-.819.818-1.94 1.938-4.06 1.938-2.12 0-3.242-1.12-4.06-1.938-.735-.736-1.097-1.062-1.94-1.062s-1.203.325-1.94 1.06c-.817.82-1.939 1.94-4.06 1.94-2.121 0-3.241-1.12-4.06-1.938-.737-.736-1.097-1.062-1.94-1.062s-1.204.325-1.94 1.062c-.819.818-1.939 1.938-4.06 1.938v-3c.843 0 1.203-.325 1.94-1.06.817-.82 1.939-1.94 4.06-1.94 2.121 0 3.241 1.12 4.06 1.938.737.736 1.097 1.062 1.94 1.062s1.204-.325 1.94-1.062c.819-.818 1.939-1.938 4.06-1.938 2.121 0 3.242 1.12 4.06 1.94.737.735 1.097 1.06 1.94 1.06s1.203-.325 1.94-1.06c.819-.82 1.939-1.94 4.06-1.94 2.121 0 3.242 1.12 4.06 1.94.737.735 1.097 1.06 1.94 1.06.844 0 1.205-.325 1.938-1.06.819-.818 1.938-1.94 4.062-1.94 2.124 0 3.243 1.122 4.062 1.94.733.735 1.094 1.06 1.938 1.06v3zM63 46.5c-2.124 0-3.245-1.122-4.062-1.94-.733-.735-1.094-1.06-1.938-1.06-.844 0-1.205.325-1.938 1.06-.817.818-1.938 1.94-4.062 1.94-2.121 0-3.242-1.12-4.06-1.94-.737-.735-1.097-1.06-1.94-1.06s-1.205.325-1.94 1.062c-.819.818-1.94 1.938-4.06 1.938-2.12 0-3.242-1.12-4.06-1.938-.735-.736-1.097-1.062-1.94-1.062s-1.203.325-1.94 1.06c-.817.82-1.939 1.94-4.06 1.94-2.121 0-3.241-1.12-4.06-1.938-.737-.736-1.097-1.062-1.94-1.062s-1.204.325-1.94 1.062c-.819.818-1.939 1.938-4.06 1.938v-3c.843 0 1.203-.325 1.94-1.06.817-.82 1.939-1.94 4.06-1.94 2.121 0 3.241 1.12 4.06 1.938.737.736 1.097 1.062 1.94 1.062s1.204-.325 1.94-1.062c.819-.818 1.939-1.938 4.06-1.938 2.121 0 3.242 1.12 4.06 1.94.737.735 1.097 1.06 1.94 1.06s1.203-.325 1.94-1.06c.819-.82 1.939-1.94 4.06-1.94 2.121 0 3.242 1.12 4.06 1.94.737.735 1.097 1.06 1.94 1.06.844 0 1.205-.325 1.938-1.06.819-.818 1.938-1.94 4.062-1.94 2.124 0 3.243 1.122 4.062 1.94.733.735 1.094 1.06 1.938 1.06v3zM63 55.5c-2.124 0-3.245-1.122-4.062-1.94-.733-.735-1.094-1.06-1.938-1.06-.844 0-1.205.325-1.938 1.06-.817.818-1.938 1.94-4.062 1.94-2.121 0-3.242-1.12-4.06-1.94-.737-.735-1.097-1.06-1.94-1.06s-1.205.325-1.94 1.062c-.819.818-1.94 1.938-4.06 1.938-2.12 0-3.242-1.12-4.06-1.938-.735-.736-1.097-1.062-1.94-1.062s-1.203.325-1.94 1.06c-.817.82-1.939 1.94-4.06 1.94-2.121 0-3.241-1.12-4.06-1.938-.737-.736-1.097-1.062-1.94-1.062s-1.204.325-1.94 1.062c-.819.818-1.939 1.938-4.06 1.938v-3c.843 0 1.203-.325 1.94-1.06.817-.82 1.939-1.94 4.06-1.94 2.121 0 3.241 1.12 4.06 1.938.737.736 1.097 1.062 1.94 1.062s1.204-.325 1.94-1.062c.819-.818 1.939-1.938 4.06-1.938 2.121 0 3.242 1.12 4.06 1.94.737.735 1.097 1.06 1.94 1.06s1.203-.325 1.94-1.06c.819-.82 1.939-1.94 4.06-1.94 2.121 0 3.242 1.12 4.06 1.94.737.735 1.097 1.06 1.94 1.06.844 0 1.205-.325 1.938-1.06.819-.818 1.938-1.94 4.062-1.94 2.124 0 3.243 1.122 4.062 1.94.733.735 1.094 1.06 1.938 1.06v3z"
          fill="#222829"
          mask="url(#b)"
        />
        <path fill="#222829" mask="url(#b)" d="M37.5 63L40.5 63 40.5 60 37.5 60z" />
        <path fill="#222829" mask="url(#b)" d="M31.5 63L34.5 63 34.5 60 31.5 60z" />
        <path fill="#222829" mask="url(#b)" d="M43.5 63L46.5 63 46.5 60 43.5 60z" />
      </g>
    </svg>
  );
}
